import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { WalkinAppointmentListModel } from "src/app/model/WalkinAppointmentListModel";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { MasterService } from "src/app/services/master.service";
import { LoaderComponent } from "../loader/loader.component";
import { MatDialog } from "@angular/material/dialog";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";

@Component({
  selector: "app-secure-walkin-appointment-list",
  templateUrl: "./walkin-appointment-list.component.html",
  styleUrls: ["./walkin-appointment-list.component.scss"],
})
export class WalkinAppointmentListComponent implements OnInit, AfterViewInit {
  list: Page<WalkinAppointmentListModel>;
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<WalkinAppointmentListModel> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicantName",
    "authority",
    "appointment",
    "createdOn",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100,200,500];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  selectedLanguageHeader: string = 'en';
  totalAppointments: number = 0;
  progressSpinnerDialog: any = null;

  constructor(
    private router: Router,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private excelExportService: ExcelExportService,
    private dialog: MatDialog,
    
  ) {}

  // ngOnInit(): void {
  //   this.loadData();
  //   // this.filterForm = new FormGroup({
  //   //   filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
  //   // });

  //   this.filterForm = new FormGroup({
  //     filterText: new FormControl(null),
  //     fromDate: new FormControl(null),
  //     toDate: new FormControl(null)
  //   });
  // }

  // ngOnInit(): void {
  //   this.loadData();
  
  //   // this.filterForm = new FormGroup({
  //   //   filterText: new FormControl(null),
  //   //   fromDate: new FormControl(null),
  //   //   toDate: new FormControl(null)
  //   // });
  //   this.filterForm = new FormGroup({
  //     filterText: new FormControl(null),
  //     fromDate: new FormControl(null),
  //     toDate: new FormControl(null),
  //     reasonFilter: new FormControl('') // default to All
  //   });
    
  
  //   // Trigger loadData() when date fields change
  //   this.filterForm.get('fromDate').valueChanges.subscribe(() => this.loadData());
  //   this.filterForm.get('toDate').valueChanges.subscribe(() => this.loadData());
  //   this.loadData();
  // }
  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null),
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
      reasonFilter: new FormControl('')
    });
  
    this.filterForm.get('fromDate').valueChanges.subscribe(() => this.loadData());
    this.filterForm.get('toDate').valueChanges.subscribe(() => this.loadData());
    this.filterForm.get('reasonFilter').valueChanges.subscribe(() => this.loadData());

    this.loadData(); // Call AFTER filterForm is ready
  }
  
  
  // export() {
  //   const currentData = this.dataSource.data;
  //   if (currentData && currentData.length > 0) {
  //     const lst: { [key: string]: string }[] = currentData.map(walkin => ({
  //       'Applicant Name': walkin.applicantName,
  //       'Appointment': walkin.appointmentDate,
  //       'Appointment Start Time': walkin.appointmentStartTime,
  //       'Appointment End Time': walkin.appointmentEndTime,
  //       'Authority': walkin.authority,
  //       'Created On': walkin.createdOn ? new Date(walkin.createdOn).toLocaleDateString() : ''
  //     }));
  
  //     this.excelExportService.exportExcel(
  //       "Walkin Appointment Detail",
  //       ["Applicant Name", "Appointment", "Appointment Start Time", "Appointment End Time", "Authority", "Created On"],
  //       lst,
  //       "50,30,30,30,30,30",
  //       "User",
  //       new Date().toISOString()
  //     );
  //   } else {
  //     this._snackBar.open("No data available for export", "Close", {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "warning-toast",
  //       duration: 3000
  //     });
  //   }
  // }
  
  export() {
    const filterText = this.filterForm.value?.filterText || null;
    const fromDateValue = this.filterForm.value?.fromDate;
    const toDateValue = this.filterForm.value?.toDate;
    const fromDate = fromDateValue ? this.formatDateLocal(new Date(fromDateValue)) : null;
    const toDate = toDateValue ? this.formatDateLocal(new Date(toDateValue)) : null;
  
    const reasonFilter = this.filterForm.get('reasonFilter')?.value;
    let reason: string | null = '';
    if (reasonFilter === 'not-null') reason = 'NOT_NULL';
    else if (reasonFilter === 'null') reason = 'NULL';
  
    const allDataPageSize = 50000;
    const allDataPage = 0;
  
    this.displayProgressSpinner();
  
    this.masterService
      .fetchWalkinAppointmentList(allDataPage, allDataPageSize, filterText, fromDate, toDate, reason)
      .subscribe(
        (page) => {
          this.progressSpinnerDialog.close();
  
          if (!page.content || page.content.length === 0) {
            this._snackBar.open("No data available for export", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3000,
            });
            return;
          }
  
          const exportData = page.content.map(walkin => ({
            'Applicant Name': walkin.applicantName,
            'Appointment': walkin.appointmentDate,
            'Appointment Start Time': walkin.appointmentStartTime,
            'Appointment End Time': walkin.appointmentEndTime,
            'Authority': walkin.authority,
            'Created On': walkin.createdOn ? new Date(walkin.createdOn).toLocaleDateString() : ''
          }));
  
          this.excelExportService.exportExcel(
            "Walkin Appointment Detail",
            ["Applicant Name", "Appointment", "Appointment Start Time", "Appointment End Time", "Authority", "Created On"],
            exportData,
            "50,30,30,30,30,30",
            "User",
            new Date().toISOString()
          );
        },
        (error) => {
          this.progressSpinnerDialog.close();
          console.error("Export failed", error);
        }
      );
  }
  exportAllData() {
    const filterText = this.filterForm.value?.filterText || null;
    const fromDateValue = this.filterForm.value?.fromDate;
    const toDateValue = this.filterForm.value?.toDate;
    const fromDate = fromDateValue ? this.formatDateLocal(new Date(fromDateValue)) : null;
    const toDate = toDateValue ? this.formatDateLocal(new Date(toDateValue)) : null;
  
    const reasonFilter = this.filterForm.get('reasonFilter')?.value;
    let reason: string | null = '';
    if (reasonFilter === 'not-null') reason = 'NOT_NULL';
    else if (reasonFilter === 'null') reason = 'NULL';
  
    const pageSize = 2000; 
    let currentPage = 0;
    let allData: WalkinAppointmentListModel[] = [];
  
    this.displayProgressSpinner();
  
    const fetchPage = () => {
      return this.masterService.fetchWalkinAppointmentList(
        currentPage,
        pageSize,
        filterText,
        fromDate,
        toDate,
        reason
      ).toPromise();
    };
  
    const fetchAllPages = async () => {
      try {
        while (true) {
          const page = await fetchPage();
          if (page.content && page.content.length > 0) {
            allData = allData.concat(page.content);
            currentPage++;
  
            if (allData.length >= page.totalElements) {
              break; 
            }
          } else {
            break; 
          }
        }
  
        this.progressSpinnerDialog.close();
  
        if (allData.length === 0) {
          this._snackBar.open("No data available for export", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3000,
          });
          return;
        }
  
        const exportData = allData.map(walkin => ({
          'Applicant Name': walkin.applicantName,
          'Document Type': walkin.documentType,
          'Document Id': walkin.aadhaar,
          'Appointment Date': walkin.appointmentDate,
          'Appointment Start Time': walkin.appointmentStartTime,
          'Appointment End Time': walkin.appointmentEndTime,
          'Authority': walkin.authority,
          'Mobile': walkin.mobileNumber,
        //  'Created On': walkin.createdOn ? new Date(walkin.createdOn).toLocaleDateString() : '',
          'Reason': walkin.subject,
          'Other Authority name': walkin.otherAuthority,
          'Board Name': walkin.boardName,

        }));
  
        this.excelExportService.exportExcel(
          "Walkin Appointment Detail",
          // ["Applicant Name", "Appointment Date", "Appointment Start Time", "Appointment End Time", "Authority", "Mobile","Created On","Reason","Other Authority name","Board Name"],
          ["Applicant Name","Document Type","Document Id", "Appointment Date", "Appointment Start Time", "Appointment End Time", "Authority", "Mobile","Reason","Other Authority name","Board Name"],

          exportData,
          "50,30,30,30,30,30,30,30,30,30,30,30",
          "User",
          new Date().toISOString()
        );
  
      } catch (error) {
        this.progressSpinnerDialog.close();
        console.error("Export failed", error);
        this._snackBar.open("Export failed. Please try again.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3000,
        });
      }
    };
  
    fetchAllPages();
  }

  
  
  onSearch() {
    if (this.filterForm.valid) {
      this.loadData();
    }
    else {
      this._snackBar.open("Please enter Filter text (minimum - 3 char)", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }

  // resetFilter() {
  //   this.filterForm.controls['filterText'].setValue(null);
  //   this.loadData();
  // }
  resetFilter() {
    this.filterForm.reset(); 
    this.currentPage = 0;    
    this.loadData();        
  }
  

  // loadData() {
  //   this.isLoading = true;
  //   console.log('this.filterForm.value', this.filterForm.value, this.filterForm.value?.filterText, 
  //   this.filterForm.value?.filterText !== undefined);
  //   this.masterService.fetchWalkinAppointmentList(this.currentPage, this.pageSize, 
  //     this.filterForm.value?.filterText != undefined ? 
  //     this.filterForm.value?.filterText
  //     : null
  //     ).subscribe((page) => {
  //       this.isLoading = false;
  //       console.log(page);
  //       this.list = page;
  //       this.dataSource = new MatTableDataSource(page.content);
  //       setTimeout(() => {
  //         this.paginator.pageIndex = this.currentPage;
  //         this.paginator.length = page.totalElements;
  //       });
  //       this.isSearchDisabled = false;
  //     },
  //     (error) => {
  //       console.log(error);
  //       this.isLoading = false;
  //       this.isSearchDisabled = false;
  //     }
  //   );
  // }

  loadData() {
    this.isLoading = true;
    this.displayProgressSpinner1();
    const filterText = this.filterForm.value?.filterText || null;
  
    const fromDateValue = this.filterForm.value?.fromDate;
    const toDateValue = this.filterForm.value?.toDate;
  
    const fromDate = fromDateValue ? this.formatDateLocal(new Date(fromDateValue)) : null;
    const toDate = toDateValue ? this.formatDateLocal(new Date(toDateValue)) : null;
  
    const reasonFilter = this.filterForm.get('reasonFilter')?.value;
    console.log('Selected Reason Filter from form:', reasonFilter);
  
    let reason: string | null = '';
    if (reasonFilter === 'not-null') {
      reason = 'NOT_NULL';
    } else if (reasonFilter === 'null') {
      reason = 'NULL';
    } else {
      reason = '';
    }
  
    console.log("Final reason to send: ", reason);
  
    this.masterService
      .fetchWalkinAppointmentList(this.currentPage, this.pageSize, filterText, fromDate, toDate, reason)
      .subscribe(
        (page) => {
          this.isLoading = false;
          this.list = page;
          this.dataSource = new MatTableDataSource(page.content);
        //  this.totalAppointments = page.content.length;
            this.totalAppointments = page.totalElements;

          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
  
          this.isSearchDisabled = false;
          this.progressSpinnerDialog.close();
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
          this.progressSpinnerDialog.close();
        }
      );
  }
  
  
  formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
  

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  // download(key: number) {
  //   this.masterService.downloadGatePassWalkin(key)
  //   .subscribe((data) => {
  //     if(data.status === 'SUCCESS') {
  //       this.downloadFile(data.data, "GatePass_"+key+".pdf");
  //     }
  //     else {
  //       this.masterService.errorToast("Unable to download Gate Pass");
  //     }
  //   },
  //   (error) => {
  //     console.log(error);
  //     this.isLoading = false;
  //     this.isSearchDisabled = false;
  //   });
  // }

  // download(key: number) {
  //   console.log('Selected Language:', this.selectedLanguageHeader); // 👈 log here
  //   this.masterService.downloadGatePassWalkin(key, this.selectedLanguageHeader)
  //     .subscribe((data) => {
  //       if (data.status === 'SUCCESS') {
  //         this.downloadFile(data.data, "GatePass_" + key + ".pdf");
  //       } else {
  //         this.masterService.errorToast("Unable to download Gate Pass");
  //       }
  //     }, (error) => {
  //       console.log(error);
  //       this.isLoading = false;
  //       this.isSearchDisabled = false;
  //     });
  // }
  
  download(key: number) {
    console.log('Selected Language:', this.selectedLanguageHeader); // 👈 log here
    this.masterService.downloadGatePassWalkin(key)
      .subscribe((data) => {
        if (data.status === 'SUCCESS') {
          this.downloadFile(data.data, "GatePass_" + key + ".pdf");
        } else {
          this.masterService.errorToast("Unable to download Gate Pass");
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
      });
  }

  // print(key: number) {
  //   this.masterService.downloadGatePassWalkin(key, this.selectedLanguageHeader)
  //   .subscribe((data) => {
  //     if(data.status === 'SUCCESS') {
  //       this.printFile(data.data);
  //     }
  //     else {
  //       this.masterService.errorToast("Unable to download Gate Pass");
  //     }
  //   },
  //   (error) => {
  //     console.log(error);
  //     this.isLoading = false;
  //     this.isSearchDisabled = false;
  //   });
  // }
  print(key: number) {
    this.masterService.downloadGatePassWalkin(key)
    .subscribe((data) => {
      if(data.status === 'SUCCESS') {
        this.printFile(data.data);
      }
      else {
        this.masterService.errorToast("Unable to download Gate Pass");
      }
    },
    (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
    });
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate")) {
      // this.masterService.toggleActivationQueryExecutor(key, 'N').subscribe((data: any)=>{
      //   if(data.status === 'SUCCESS') {
      //     let selectedObj = this.queryExecutorList.content.find(o => o.key === key);
      //     selectedObj.activeFlag = 'N';
      //     this.reportService.successToast('Query Executor de-activated successfully');
      //   }
      //   else {
      //     this.reportService.errorToast(data.errorMessage);
      //   }
      // });
    } 
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `data:application/pdf;base64,${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  printFile(base64: string | ArrayBuffer, mimeType = 'application/pdf') {
    let blob: Blob;
  
    if (typeof base64 === 'string') {
      // Strip metadata prefix if present
      const base64Content = base64.includes(',') ? base64.split(',')[1] : base64;
      const byteCharacters = atob(base64Content);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray], { type: mimeType });
    } else {
      blob = new Blob([base64], { type: mimeType });
    }
  
    const blobUrl = URL.createObjectURL(blob);
  
    const printWindow = window.open(blobUrl, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
      };
    } else {
      console.error("Popup blocked. Allow popups for this site to enable printing.");
    }
  
    // Optionally revoke after some delay to ensure printing works
    setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
  }
  
  async displayProgressSpinner() {
     this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
       disableClose: true,
       panelClass: "progressSpinner",
     });
   }
  displayProgressSpinner1(): void {
    if (!this.progressSpinnerDialog) {
      this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
        disableClose: true
      });
    }
  }
  
   
  activate(key: number) {
    if(confirm("Do you want to Activate the Query Executor")) {
      // this.reportService.toggleActivationQueryExecutor(key, 'Y').subscribe((data: any)=>{
      //   if(data.status === 'SUCCESS') {
      //     let selectedObj = this.queryExecutorList.content.find(o => o.key === key);
      //     selectedObj.activeFlag = 'Y';
      //     this.reportService.successToast('Query Executor activated successfully');
      //   }
      //   else {
      //     this.reportService.errorToast(data.errorMessage);
      //   }
      // });
    } 
  }
}